import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { Trash2, ShoppingBag, ArrowRight, MapPin } from "lucide-react";

export default function Cart() {
  const { items, remove, setQty, total } = useCart();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-app relative pt-12 pb-28" data-testid="cart-page">
      <div className="absolute inset-0 hud-grid opacity-15" />
      <div className="relative mx-auto max-w-4xl px-5">
        <div className="font-mono text-[11px] tracking-[0.4em] text-cyan/70">MANIFEST</div>
        <h1 className="font-head text-4xl font-bold uppercase mt-2 mb-8">Your <span className="text-cyan text-glow-cyan">Cart</span></h1>

        {items.length === 0 ? (
          <div className="glass clip-chamfer brackets p-14 text-center">
            <ShoppingBag className="w-10 h-10 text-cyan/40 mx-auto mb-4" />
            <p className="text-slate-400">Your manifest is empty.</p>
            <Link to="/shop" className="btn-hud inline-flex mt-6 border border-cyan/40 text-cyan px-6 py-2.5 text-sm hover:bg-cyan hover:text-app">
              Browse Depot
            </Link>
          </div>
        ) : (
          <>
            <div className="space-y-3" data-testid="cart-items">
              {items.map((it) => (
                <div key={it.key} className="glass flex items-center gap-4 p-4 border border-cyan/15" data-testid={`cart-item-${it.product_id}`}>
                  <img src={it.image} alt={it.name} className="w-20 h-20 object-contain bg-app border border-white/10" />
                  <div className="flex-1 min-w-0">
                    <div className="font-head text-lg uppercase text-slate-100">{it.name}</div>
                    <div className="font-mono text-[10px] tracking-widest text-slate-500">
                      {it.type} · SIZE {it.size}{it.custom ? ` · ${it.color || "CUSTOM"}` : ""}
                    </div>
                    {it.custom && <div className="font-mono text-[9px] tracking-widest text-amber/80 mt-0.5">CUSTOM DESIGN · +$5{it.has_back ? " · FRONT+BACK +$6" : ""}</div>}
                    <div className="font-head text-lg mt-1" style={{ color: it.accent }}>${it.price.toFixed(2)}</div>
                  </div>
                  <div className="flex items-center border border-white/15">
                    <button onClick={() => setQty(it.key, it.qty - 1)} className="w-8 h-8 text-cyan hover:bg-cyan/10">−</button>
                    <span className="w-8 text-center font-mono text-sm">{it.qty}</span>
                    <button onClick={() => setQty(it.key, it.qty + 1)} className="w-8 h-8 text-cyan hover:bg-cyan/10">+</button>
                  </div>
                  <button onClick={() => remove(it.key)} data-testid={`remove-${it.product_id}`} className="text-slate-500 hover:text-amber p-2">
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              ))}
            </div>

            <div className="glass-strong clip-chamfer brackets p-6 mt-6">
              <div className="flex items-center justify-between mb-2">
                <span className="font-mono text-xs tracking-widest text-slate-400">SUBTOTAL</span>
                <span className="font-head text-2xl font-bold text-cyan" data-testid="cart-total">${total.toFixed(2)}</span>
              </div>
              <div className="flex items-center gap-2 font-mono text-[10px] tracking-widest text-slate-500 mb-5">
                <MapPin className="w-3 h-3 text-cyan" /> PRINT-ON-DEMAND · NICOSIA, CYPRUS · SHIPPING CALCULATED AT CHECKOUT
              </div>
              <button
                onClick={() => navigate("/shop/checkout")}
                data-testid="proceed-checkout-btn"
                className="btn-hud w-full flex items-center justify-center gap-2 border border-cyan text-cyan py-3.5 text-sm box-glow-cyan hover:bg-cyan hover:text-app"
              >
                Proceed to Checkout <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
